(() => {
  const init = (root) => {
    if (!root || root.dataset.tmaReady === 'true') return;
    root.dataset.tmaReady = 'true';

    const items = root.querySelectorAll('.tma-reveal');
    if (!items.length) return;

    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches || !('IntersectionObserver' in window)) {
      items.forEach((item) => item.classList.add('is-visible'));
      return;
    }

    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('is-visible');
        observer.unobserve(entry.target);
      });
    }, { threshold: 0.08, rootMargin: '0px 0px -30px' });

    items.forEach((item, index) => {
      item.style.transitionDelay = `${Math.min(index % 4, 3) * 70}ms`;
      observer.observe(item);
    });
  };

  const initAll = () => document.querySelectorAll('[data-tma-home]').forEach(init);
  document.addEventListener('DOMContentLoaded', initAll, { once: true });
  document.addEventListener('shopify:section:load', (event) => init(event.target.querySelector('[data-tma-home]')));
})();
